module.exports = __webpack_public_path__ + "img/ic-search.75fee13f.svg";